<template>
  <MarketplaceCard
    v-if="zapierIntegrations"
    :model-value="zapierIntegrations.zapier.enabled"
    logo-alt="Zapier"
    description="Event-driven workflow automation powered by Zapier."
    learn-more-link="https://zapier.com/apps/sera-systems/integrations"
    cy-selector="marketplaceZapier"
    @update:model-value="onToggle"
  >
    <template #logo>
      <ZapierLogo class="h-11 w-auto mr-auto" />
    </template>
    <template #configure>
      <!-- Zapier 2.0 offered: one page for the API keys and the subscriptions. -->
      <div v-if="zapierV2Available">
        <a href="/marketplace/zapier" class="link" data-cy="zapier-manage">
          Manage Zapier
        </a>
      </div>
      <!-- Not offered: the card as it was. -->
      <div v-else>
        <div
          v-if="zapierIntegrations.zapier.enabled"
          class="link"
          @click="toggleModal"
        >
          View & Copy API Key
        </div>
        <div v-else class="text-gray">View & Copy API Key</div>
        <a
          href="/marketplace/zapier"
          class="link"
          data-cy="zapier-view-subscriptions"
        >
          View subscriptions
        </a>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Zapier Configuration API Key"
          class-name="zapier-config-modal"
          @hide-modal="toggleModal"
        >
          <template #submit>
            <AppButton @click="handleCopy">
              <span
                ><span v-if="!copied">Copy API Key</span
                ><span v-else>Copied to clipboard</span></span
              >
            </AppButton>
          </template>
          <div class="d-flex flex-column">
            <InputField
              v-model="zapierIntegrations.zapier.api_key"
              :disabled="true"
              title="API Key"
              placeholder="API Key"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import InputField from "@/components/Seranova/InputField/InputField.vue";
import ZapierLogo from "@/images/zapier_logo.svg?component";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    InputField,
    ZapierLogo,
    AppButton: Button
  },
  data() {
    return {
      modalOpen: false,
      copied: false
    };
  },
  computed: {
    ...mapState(["zapierIntegrations"]),
    // With the zapier_engine flag off the card is what it was before 2.0: the
    // 1.x key in a plain modal, and a link to the subscriptions. With it on,
    // the keys and the subscriptions are tabs of one page.
    zapierV2Available() {
      return !!this.zapierIntegrations?.zapier_v2?.available;
    }
  },
  mounted() {
    this.fetchZapierIntegrations();
  },
  methods: {
    ...mapActions(["fetchZapierIntegrations", "updateZapierIntegrations"]),
    // Saved when the switch is flipped, not when the state changes: the state
    // also changes when it loads, and it is still there when you come back to
    // this page from the Zapier page, so a watcher can't tell the two apart.
    onToggle(enabled) {
      this.zapierIntegrations.zapier.enabled = enabled;
      this.updateEnabled();
    },
    updateEnabled() {
      const en = this.zapierIntegrations.zapier.enabled;
      this.updateZapierIntegrations({
        zapierIntegrations: { zapier: { enabled: en } }
      }).then(() => {
        window.notify.success(`Zapier ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
      if (!this.modalOpen) this.copied = false;
    },
    handleCopy() {
      navigator.clipboard
        .writeText(this.zapierIntegrations.zapier.api_key)
        .then(() => (this.copied = true));
    }
  }
};
</script>
